import { useState } from "react";
import * as stringSimilarity from 'string-similarity';

export default function useGroupBySimilarNames({ datas, similarityThreshold = 0.75 }) {
    const [groupedNames, setGroupedNames] = useState([]);
    const [loading, setLoading] = useState(false);


    // Predefined color palette (expand as needed)
    const COLORS = [
        "#FF6B6B", // Vibrant coral
        "#4ECDC4", // Tiffany blue
        // "#45B7D1", // Bright azure
        "#FFBE0B", // Golden yellow
        "#8338EC", // Electric purple
        "#3A86FF", // Bold blue
        "#FF006E", // Hot pink
        "#A5DD9B", // Vibrant mint
        "#F9C74F", // Sunflower yellow
        "#90BE6D", // Leaf green
        "#43AA8B", // Jade green
        "#577590", // Steel blue
        "#F94144", // Fire engine red
        "#F3722C", // Pumpkin orange
        "#F8961E", // Mango
        "#277DA1", // Marine blue
        "#774936", // Chocolate brown
        "#5C4D7D", // Royal purple
        "#A63A50", // Ruby red
        "#2EC4B6", // Pacific cyan
        "#E71D36", // Neon red
        "#662E9B", // Amethyst
        "#FB5607", // Vivid orange
        "#2D7DD2", // Denim blue
        "#EE6352", // Salmon
        "#59CD90", // Emerald
        "#3FA7D6", // Pool blue
        "#FAC05E", // Buttercup
        "#F79D84", // Melon
        "#7D82B8"  // Periwinkle
      ];

    // Helper: Generate a deterministic color from a string (e.g., group key)

    // Assign a color based on group index (cycles through COLORS)
    const getColorForGroup = (index) => COLORS[index % COLORS.length];

    // Normalize a name for comparison (lowercase, trim, ignore accents)
    const normalizeName = (str) =>
        str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();

    // Compare two name objects for similarity
    const areNamesSimilar = (person1, person2) => {
        const fullName1 = person1.fullName ? `${normalizeName(person1.fullName)}` : `${normalizeName(person1.firstName)} ${normalizeName(person1.lastName)}`;
        const fullName2 = person2.fullName ? `${normalizeName(person2.fullName)}` : `${normalizeName(person2.firstName)} ${normalizeName(person2.lastName)}`;
        return stringSimilarity.compareTwoStrings(fullName1, fullName2) >= similarityThreshold; // Adjust threshold
    };

    const groupSimilarNames = ({ people = datas }) => {
        setLoading(true)
        const groups = [];
        const usedIndices = new Set();


        people.forEach((person1, i) => {
            if (usedIndices.has(i)) return;

            const groupKey = person1.fullName ? person1.fullName : `${person1.firstName} ${person1.lastName}`;
            const group = {
                key: groupKey,
                people: [person1],
                color: getColorForGroup(groups.length), // Assign next color from palette
            };

            usedIndices.add(i);

            // Compare with other people
            people.forEach((person2, j) => {
                if (i === j || usedIndices.has(j)) return;
                if (areNamesSimilar(person1, person2)) {
                    group.people.push(person2);
                    usedIndices.add(j);
                }
            });
            // Only add group if it has more than 1 member
            if (group.people.length > 1) {
                groups.push(group);
            }
        });


        setGroupedNames(groups);
        setLoading(false)

    };


    return { groupSimilarNames, groupedNames, loadingGroupedNames: loading };

}